const IMPRESSAO_DESATUALIZADA = 'Impressão desatualizada! ',
      DIGITALIZACAO_DESATUALIZADA = 'Digitalização desatualizada! ',
      INDICAR_POSSUI_INDISPONIBILIDADE = 'Indicador possui ordens de indisponibilidade ativas! ',
      INDICADOR_POSSUI_FIRMA_ABERTA = 'Indicador possui firma aberta! ',
      INDICAR_POSSUI_OCORRENCIAS = 'Indicador possui ocorrências ativas! ',
      REGISTRO_POSSUI_OCORRENCIAS = 'Registro possui ocorrências ativas! ',
      INDICAR_POSSUI_PROTOCOLOS = 'Indicador possui protocolos vinculados! ',
      INDICAR_POSSUI_SALDO_PENDENTE = 'Pessoa possui saldo pendente em outros protocolos',
      INDICAR_POSSUI_BLOQUEIO_SAEC = 'Matrícula com bloqueio de visualização no SAEC conforme a LGPD',
      REGAUXILIAR_POSSUI_PROTOCOLOS = 'Registro auxiliar possui protocolos vinculados! ',
      PROTOCOLO_POSSUI_VINCULOS = 'Não existe Matrícula/Transcrição ou Registro Auxiliar vinculado.',
      PROTOCOLO_SELOS_COM_ERRO = 'Existem selos não enviados ou com erro neste protocolo.',
      INDICADOR_PESSOA_EXPOSTA_POLITICAMENTE = 'Indicador é pessoa politicamente exposta (PEP)',
      ATO_INCOMPLETO = 'Ato incompleto! ',
      ATO_SEM_EFEITO = 'Ato sem efeito! ';

export default {

  impressaoDesatualizada() {
    return IMPRESSAO_DESATUALIZADA;
  },

  digitalizacaoDesatualizada() {
    return DIGITALIZACAO_DESATUALIZADA;
  },

  indicadorPossuiIndisponibilidade() {
    return INDICAR_POSSUI_INDISPONIBILIDADE;
  },

  indicadorPossuiFirmaAberta() {
    return INDICADOR_POSSUI_FIRMA_ABERTA;
  },

  indicadorPossuiOcorrencias() {
    return INDICAR_POSSUI_OCORRENCIAS;
  },

  registroPossuiOcorrencias() {
    return REGISTRO_POSSUI_OCORRENCIAS;
  },

  indicadorPossuiProtocolos() {
    return INDICAR_POSSUI_PROTOCOLOS;
  },

  indicadorPossuiSaldoPendente() {
    return INDICAR_POSSUI_SALDO_PENDENTE;
  },

  indicadorPossuiBloqueioSaec() {
    return INDICAR_POSSUI_BLOQUEIO_SAEC;
  },

  registroAuxiliarPossuiProtocolos() {
    return REGAUXILIAR_POSSUI_PROTOCOLOS;
  },

  protocoloPossuiVinculos() {
    return PROTOCOLO_POSSUI_VINCULOS;
  },
  protocoloPossuiSeloComErro() {
    return PROTOCOLO_SELOS_COM_ERRO;
  },

  indicadorPessoaExpostaPoliticamente() {
    return INDICADOR_PESSOA_EXPOSTA_POLITICAMENTE;
  },

  atoIncompleto() {
    return ATO_INCOMPLETO;
  },

  atoSemEfeito() {
    return ATO_SEM_EFEITO;
  },
}
